import { Component, OnInit } from '@angular/core';
import { IngredientService } from '../../../services/ingredient.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { BaseComponent } from '../../base.component';

@Component({
	selector: 'app-ingredient',
	templateUrl: './ingredient.component.html',
	styleUrls: ['./ingredient.component.css']
})
export class IngredientComponent extends BaseComponent implements OnInit {
	id:any;

	constructor(
		private ingredientService: IngredientService,
		private router: Router,
		private route: ActivatedRoute
	) {
		super();
	}

	ngOnInit() {
		this.id = this.route.snapshot.params['id'];
	}

}



// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/components/ingredient/ingredient/ingredient.component.ts